import styled from 'styled-components';
import { OCardLayeredStandardAspectRatio } from './OCardLayeredStandard.types';

interface WrapperProps {
  aspectRatio: OCardLayeredStandardAspectRatio;
  isClickable: boolean;
}

interface ImageContainerProps {
  aspectRatio: OCardLayeredStandardAspectRatio;
}

const getAspectRatioValue = (aspectRatio: OCardLayeredStandardAspectRatio): string => {
  switch (aspectRatio) {
    case OCardLayeredStandardAspectRatio.TALL_1_2:
      return '1 / 2';
    case OCardLayeredStandardAspectRatio.WIDE_3_2:
      return '3 / 2';
    case OCardLayeredStandardAspectRatio.TALL_2_3:
      return '2 / 3';
    case OCardLayeredStandardAspectRatio.TALL_9_16:
      return '9 / 16';
    case OCardLayeredStandardAspectRatio.SQUARE_1_1:
      return '1 / 1';
    case OCardLayeredStandardAspectRatio.WIDE_16_9:
      return '16 / 9';
    default:
      return '16 / 9';
  }
};

export const Wrapper = styled.article<WrapperProps>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => getAspectRatioValue(aspectRatio)};
  overflow: hidden;
  border-radius: var(--t-cards-border-radius, 14px);
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: transform 0.3s ease;

  &:hover {
    transform: ${({ isClickable }) => (isClickable ? 'scale(1.02)' : 'none')};
  }

  &.inverse {
    button,
    button *,
    a[role='button'],
    a[role='button'] * {
      color: revert;
    }
  }
`;

export const ImageContainer = styled.div<ImageContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  aspect-ratio: ${({ aspectRatio }) => getAspectRatioValue(aspectRatio)};

  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContentOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1.5rem;
  z-index: 1;

  @media (min-width: 768px) {
    padding: 2rem;
  }

  @media (min-width: 992px) {
    padding: 2.5rem;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    top: 2rem;
    left: 2rem;
  }
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextBlockWrapper = styled.div``;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`;

export const IconButtonWrapper = styled.div`
  position: absolute;
  botton: 2.5rem;
  right: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
